import type { EdutainmentOrder } from './types';

// TODO: 測試用資料，記得刪除
export const DUMMY_ORDER_LIST: EdutainmentOrder[] = [
  {
    _id: '1',
    programName: '兒童程式設計入門班',
    status: '報名中',
    orderNumber: 'EDU20240101001',
    createdTime: 1704067200000, // 2024-01-01
    memberName: '王小明',
    phoneNumber: '0912345678',
    payment: '信用卡',
    price: 3000,
    rating: null,
    review: null,
    cancelable: true,
    hasNotes: true,
  },
  {
    _id: '2',
    programName: '機器人科學營',
    status: '已評價',
    orderNumber: 'EDU20231225002',
    createdTime: 1703462400000, // 2023-12-25
    memberName: '李小華',
    phoneNumber: '0923456789',
    payment: '點數',
    price: 5000,
    rating: 5,
    review: '課程非常有趣，小孩學到很多！',
    cancelable: false,
    hasNotes: false,
  },
  {
    _id: '3',
    programName: '科學實驗冬令營',
    status: '已取消',
    orderNumber: 'EDU20231220003',
    createdTime: 1702944000000, // 2023-12-20
    memberName: '張小芳',
    phoneNumber: '0934567890',
    payment: '未付款',
    price: 4500,
    rating: null,
    review: null,
    cancelable: false,
    hasNotes: false,
  },
  {
    _id: '4',
    programName: '數學邏輯思維班',
    status: '未付款',
    orderNumber: 'EDU20240105004',
    createdTime: 1704412800000, // 2024-01-05
    memberName: '陳大寶',
    phoneNumber: '0945678901',
    payment: '未付款',
    price: 2500,
    rating: null,
    review: null,
    cancelable: true,
    hasNotes: false,
  },
  {
    _id: '5',
    programName: '創意美術班',
    status: '已評價',
    orderNumber: 'EDU20231215005',
    createdTime: 1702598400000, // 2023-12-15
    memberName: '林小美',
    phoneNumber: '0956789012',
    payment: '信用卡',
    price: 3500,
    rating: 4,
    review: '老師教學認真，課程安排很棒',
    cancelable: false,
    hasNotes: false,
  },
  {
    _id: '6',
    programName: '英語戲劇表演班',
    status: '報名中',
    orderNumber: 'EDU20240110006',
    createdTime: 1704844800000, // 2024-01-10
    memberName: '黃小琳',
    phoneNumber: '0967890123',
    payment: '信用卡',
    price: 4000,
    rating: null,
    review: null,
    cancelable: true,
    hasNotes: false,
  },
  {
    _id: '7',
    programName: '自然探索營',
    status: '已評價',
    orderNumber: 'EDU20231230007',
    createdTime: 1703894400000, // 2023-12-30
    memberName: '周小龍',
    phoneNumber: '0978901234',
    payment: '點數',
    price: 3800,
    rating: 5,
    review: '戶外活動很豐富，孩子玩得很開心',
    cancelable: false,
    hasNotes: false,
  },
  {
    _id: '8',
    programName: '音樂創作工作坊',
    status: '未付款',
    orderNumber: 'EDU20240115008',
    createdTime: 1705276800000, // 2024-01-15
    memberName: '吳小安',
    phoneNumber: '0989012345',
    payment: '未付款',
    price: 4200,
    rating: null,
    review: null,
    cancelable: true,
    hasNotes: false,
  },
  {
    _id: '9',
    programName: '烘焙美食班',
    status: '已評價',
    orderNumber: 'EDU20231228009',
    createdTime: 1703721600000, // 2023-12-28
    memberName: '謝小玲',
    phoneNumber: '0990123456',
    payment: '信用卡',
    price: 3200,
    rating: 4,
    review: '課程內容充實，老師教學細心',
    cancelable: false,
    hasNotes: false,
  },
  {
    _id: '10',
    programName: '科技創客營',
    status: '已取消',
    orderNumber: 'EDU20240102010',
    createdTime: 1704153600000, // 2024-01-02
    memberName: '楊小光',
    phoneNumber: '0901234567',
    payment: '未付款',
    price: 4800,
    rating: null,
    review: null,
    cancelable: false,
    hasNotes: false,
  },
];
